

import { createSelector } from '@reduxjs/toolkit';
import { get } from 'lodash';
const NAME = 'application';

export const isLoading = state => state[NAME].isLoading

export const list = state => state[NAME].list
export const listIndividual = state => state[NAME].individualList
export const listNonIndividual = state => state[NAME].nonIndividualList

export const listExsitingFranchise = state => state[NAME].existingFranchiseList
export const listAuthorizedDrivers = state => state[NAME].authorizedDriversList
export const listRequirement = state => state[NAME].requirementList
export const listAppointment = state => state[NAME].appointmentsList
export const listReappointment = state => state[NAME].reappointmentsList
export const listPaymentFees = state => state[NAME].paymentFeesList
export const listPaymentTransactions= state => state[NAME].paymentTransactionList
export const listServiceUnits = state => state[NAME].serviceUnitsList
export const serviceUnits = state => state[NAME].serviceUnits

export const selectedId = state => state[NAME].selected

export const selected = createSelector(
  list,
  selectedId,
  (_, props) => props && props.id,
  (_list, _selectedId, _id) => _list[_id || _selectedId]
)

export const selectedIndividual = createSelector(
  listIndividual,
  (_, props) => props && props.id,
  (_list,  _id) => _list[_id]
)


export const selectedNonIndividual = createSelector(
  listNonIndividual,
  (_, props) => props && props.id,
  (_list,  _id) => _list[_id]
)

export const selectedAppointment = createSelector(
  listAppointment,
  (_, props) => props && props.id,
  (_list,  _id) => _list[_id]
)

export const selectedReappointment = createSelector(
  listReappointment,
  (_, props) => props && props.id,
  (_list,  _id) => _list[_id]
)

export const listPaymentFeesByArrayOfPaymentIds = createSelector(
  listPaymentFees,
  (_, props) => props && props.ids,
  (_list, _ids) => {
    return Object.entries(_list).reduce((current, accumulator) => {
      
      if(_ids.indexOf(+accumulator[0]) > -1){
        return {
          ...current,
          [accumulator[0]]: accumulator[1]
        }
      }

      return current
    }, {})
  } 
)

export const listPaymentFeesByPaymentIds = createSelector(
  listPaymentFees,
  (_, props) => props && props.id,
  (_list, _id) => {
    return Object.entries(_list).reduce((current, accumulator) => {
      
      if(+get(accumulator[1], 'attributes.payment_id') === +_id){
        return {
          ...current,
          [accumulator[0]]: accumulator[1]
        }
      }

      return current
    }, {})
  } 
)


export const selectedPaymentTransaction = createSelector(
  listPaymentTransactions,
  (_, props) => props && props.id,
  (_list,  _id) => _list[_id]
)

export const paymentTransctionTypeIdsByPaymentId = createSelector(
  listPaymentTransactions,
  (_, props) => props && props.id,
  (_list,  _id) => Object.entries(_list).reduce((current, accumulator) => {
    if(+get(accumulator, '1.attributes.payment_id') === +_id){
      return [
        ...current,
        +get(accumulator, '1.attributes.transaction_type_id')
      ]
    }

    return current
  }, [])
)

export const selectedRequirementsByPaymentId = createSelector(
  listRequirement,
  (_, props) => props && props.payment_id,
  (_list,  _paymen_id) => Object.entries(_list).reduce((current, accumulator) => {

    const key = accumulator[0]
    const data = accumulator[1]
    
    if(+get(data, 'attributes.payment_id') === +_paymen_id){
      return {
        ...current,
        [key]: data
      }
    }

    return current

  }, {})
)

export const selectedRequirementsArrayByPaymentId = createSelector(
  listRequirement,
  (_, props) => props && props.payment_id,
  (_list,  _paymen_id) => Object.entries(_list).reduce((current, accumulator) => {

    const data = accumulator[1]
    
    if(+get(data, 'attributes.payment_id') === +_paymen_id){
      return [
        ...current,
        data
      ]
    }

    return current

  }, [])
)

export const selectedExistingFranchisByApplicationId = createSelector(
  listExsitingFranchise,
  (_, props) => props && props.application_id,
  (_list,  _application_id) => Object.entries(_list).reduce((current, accumulator) => {

    const key = accumulator[0]
    const data = accumulator[1]
    
    if(+get(data, 'attributes.cpc_application_id') === +_application_id){
      return {
        ...current,
        [key]: data
      }
    }

    return current

  }, {})
)


export const selectedAuthorizedDriversByApplicationId = createSelector(
  listAuthorizedDrivers,
  (_, props) => props && props.application_id,
  (_list,  _application_id) => Object.entries(_list).reduce((current, accumulator) => {

    const key = accumulator[0]
    const data = accumulator[1]
    
    if(+get(data, 'attributes.cpc_application_id') === +_application_id){
      return {
        ...current,
        [key]: data
      }
    }

    return current

  }, {})
)

export const selectedServiceUnitsByApplicationId = createSelector(
  listServiceUnits,
  (_, props) => props && props.application_id,
  (_list,  _application_id) => Object.entries(_list).reduce((current, accumulator) => {

    const key = accumulator[0]
    const data = accumulator[1]
    
    if(+get(data, 'attributes.cpc_application_id') === +_application_id){
      return {
        ...current,
        [key]: data
      }
    }

    return current

  }, {})
)

export const selectedServiceUnits = createSelector(
  serviceUnits,
  (_, props) => props && props.id,
  (_list,  _id) => _list[_id]
)



